module.exports = __webpack_public_path__ + "static/media/RN-2025-04.c6c25017.jpg";